import { createStore } from 'satcheljs';

interface ECStore {
    isLoaded: boolean;
}

const INIT_STORE: ECStore = {
    isLoaded: false,
};
export const ECstore = createStore<ECStore>('ECStore', INIT_STORE)();
